export interface Movie {
  id: string;
  title: string;
  category: string;
  genre: string[];
  image: string;
  description: string;
  rating: number;
  year: number;
  duration: string;
  isNew: boolean;
  isHot: boolean;
  episodes?: number;
}

export const movies: Movie[] = [
  {
    id: 'mv-001',
    title: '长安十二时辰',
    category: 'tv',
    genre: ['古装', '悬疑'],
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20city%20at%20night%20with%20lanterns%20and%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20Tang%20Dynasty%20aesthetic%2C%20cinematic%20movie%20poster%20style%2C%20warm%20golden%20and%20dark%20tones%2C%20epic%20historical%20drama%20visual%2C%20clean%20composition%20with%20centered%20silhouette&width=600&height=800&seq=movie-cs12sc-01&orientation=portrait',
    description: '唐朝上元节前夕，长安城陷入一场惊天阴谋。死囚张小敬临危受命，与李必携手在十二时辰内拯救长安城。一场关于忠诚与背叛、牺牲与救赎的故事就此展开。',
    rating: 8.7,
    year: 2019,
    duration: '45分钟/集',
    isNew: false,
    isHot: true,
    episodes: 48,
  },
  {
    id: 'mv-002',
    title: '流浪地球3',
    category: 'movie',
    genre: ['科幻', '动作'],
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20giant%20planetary%20engines%20on%20a%20frozen%20Earth%20surface%2C%20dramatic%20orange%20and%20blue%20nebula%20sky%2C%20astronaut%20silhouette%20looking%20at%20distant%20galaxy%2C%20cinematic%20movie%20poster%20style%2C%20grand%20scale%2C%20atmospheric%20and%20heroic&width=600&height=800&seq=movie-lldq3-02&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器寻找新家园。面对前所未有的危机，一群勇敢的年轻人挺身而出，为人类的命运展开了生死之战。史诗级科幻巨制。',
    rating: 9.1,
    year: 2025,
    duration: '148分钟',
    isNew: true,
    isHot: true,
  },
  {
    id: 'mv-003',
    title: '隐秘的角落',
    category: 'tv',
    genre: ['悬疑', '都市'],
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20alley%20in%20a%20Chinese%20small%20town%20at%20dusk%2C%20warm%20yellow%20street%20light%2C%20lonely%20child%20standing%20in%20shadow%2C%20suspenseful%20thriller%20atmosphere%2C%20cinematic%20poster%20style%2C%20contrast%20between%20warm%20light%20and%20deep%20shadows&width=600&height=800&seq=movie-ymdjl-03&orientation=portrait',
    description: '沿海小城的暑假，三个孩子在景区游玩时无意拍摄记录了一次谋杀。由此，几个家庭的命运纠缠在一起，一步步走向不可预测的深渊。高分悬疑力作。',
    rating: 9.0,
    year: 2020,
    duration: '50分钟/集',
    isNew: false,
    isHot: true,
    episodes: 12,
  },
  {
    id: 'mv-004',
    title: '深海历险记',
    category: 'anime',
    genre: ['动画', '奇幻'],
    image: 'https://readdy.ai/api/search-image?query=Magical%20underwater%20world%20with%20colorful%20coral%20reefs%20and%20glowing%20jellyfish%2C%20young%20girl%20diving%20through%20crystal%20clear%20ocean%20water%2C%20dreamlike%20fantasy%20atmosphere%2C%20animated%20film%20poster%20style%2C%20vibrant%20blues%20and%20pinks%2C%20whimsical%20and%20enchanting&width=600&height=800&seq=movie-shlxj-04&orientation=portrait',
    description: '一个内向的小女孩在奇幻的海底世界展开冒险，与各种奇妙的海洋生物成为朋友。在寻找回家之路的过程中，她逐渐发现了勇气与友谊的真谛。',
    rating: 8.5,
    year: 2024,
    duration: '105分钟',
    isNew: true,
    isHot: false,
  },
  {
    id: 'mv-005',
    title: '武林外传',
    category: 'tv',
    genre: ['喜剧', '古装'],
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20inn%20with%20wooden%20architecture%20and%20red%20lanterns%2C%20warm%20cozy%20interior%20lighting%2C%20group%20of%20quirky%20martial%20arts%20characters%20in%20traditional%20costumes%2C%20comedic%20atmosphere%2C%20period%20drama%20poster%20style%2C%20rich%20warm%20colors&width=600&height=800&seq=movie-wlwz-05&orientation=portrait',
    description: '以明朝为背景的同福客栈里，汇集了一群性格各异的人物：掌柜佟湘玉、跑堂白展堂、杂役郭芙蓉……每天上演着啼笑皆非的故事。国产情景喜剧巅峰之作。',
    rating: 9.5,
    year: 2006,
    duration: '42分钟/集',
    isNew: false,
    isHot: false,
    episodes: 80,
  },
  {
    id: 'mv-006',
    title: '狂飙',
    category: 'tv',
    genre: ['动作', '都市'],
    image: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20scene%20with%20dark%20urban%20cityscape%20at%20night%2C%20rain-slicked%20streets%2C%20two%20figures%20in%20confrontation%20under%20street%20lamp%2C%20gritty%20cinematic%20poster%20style%2C%20high%20contrast%20noir%20lighting%2C%20tense%20atmosphere&width=600&height=800&seq=movie-kb-06&orientation=portrait',
    description: '一线刑警安欣在与黑恶势力的斗争中，与黑老大高启强展开了长达二十年的正邪较量。一部展现时代变迁中人性善恶的史诗级扫黑除恶剧集。',
    rating: 8.8,
    year: 2023,
    duration: '45分钟/集',
    isNew: false,
    isHot: true,
    episodes: 39,
  },
  {
    id: 'mv-007',
    title: '哪吒之魔童闹海',
    category: 'anime',
    genre: ['动画', '奇幻', '动作'],
    image: 'https://readdy.ai/api/search-image?query=Mythological%20Chinese%20warrior%20child%20with%20flaming%20wheels%20and%20red%20sash%20flying%20through%20stormy%20clouds%2C%20dynamic%20action%20pose%2C%20epic%20anime%20style%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20dramatic%20lightning%20and%20fire%20effects%2C%20heroic%20movie%20poster&width=600&height=800&seq=movie-nzmtnh-07&orientation=portrait',
    description: '天地灵气孕育出一颗混元珠，元始天尊将其提炼成灵珠和魔丸。灵珠投胎为人，助周伐纣；魔丸则会诞出魔王，为祸人间。然而阴差阳错，灵珠和魔丸被调换……',
    rating: 8.9,
    year: 2025,
    duration: '120分钟',
    isNew: true,
    isHot: true,
  },
  {
    id: 'mv-008',
    title: '王牌对王牌',
    category: 'variety',
    genre: ['喜剧'],
    image: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20variety%20show%20stage%20with%20bright%20studio%20lights%20and%20confetti%2C%20two%20teams%20of%20celebrities%20facing%20off%20in%20a%20game%20show%20setting%2C%20energetic%20and%20playful%20atmosphere%2C%20entertainment%20poster%20style%2C%20vibrant%20neon%20accents%20on%20dark%20background&width=600&height=800&seq=movie-wpdwp-08&orientation=portrait',
    description: '大型室内竞技真人秀，每期邀请两支王牌团队进行PK对战。经典游戏全新升级，欢乐不断，爆笑连连。明星嘉宾阵容豪华，带你感受不一样的综艺魅力。',
    rating: 8.2,
    year: 2024,
    duration: '90分钟/期',
    isNew: true,
    isHot: true,
  },
  {
    id: 'mv-009',
    title: '红海行动',
    category: 'movie',
    genre: ['动作', '战争'],
    image: 'https://readdy.ai/api/search-image?query=Intense%20modern%20military%20operation%20scene%20in%20desert%20environment%2C%20special%20forces%20team%20in%20tactical%20gear%2C%20explosive%20action%20with%20dust%20and%20debris%2C%20cinematic%20war%20movie%20poster%20style%2C%20desaturated%20warm%20tones%2C%20heroic%20and%20gritty%20atmosphere&width=600&height=800&seq=movie-hhxd-09&orientation=portrait',
    description: '中国海军蛟龙突击队八名队员奉命执行撤侨任务，在陌生的异国战场上，面对恐怖分子的重重围堵，他们用信念和鲜血铸就了一条守护同胞生命的血路。',
    rating: 8.6,
    year: 2018,
    duration: '138分钟',
    isNew: false,
    isHot: false,
  },
  {
    id: 'mv-010',
    title: '繁花',
    category: 'tv',
    genre: ['都市', '爱情'],
    image: 'https://readdy.ai/api/search-image?query=Retro%201990s%20Shanghai%20cityscape%20with%20neon%20signs%20and%20wet%20streets%20at%20night%2C%20elegant%20woman%20in%20cheongsam%20dress%20walking%20through%20the%20Bund%20area%2C%20nostalgic%20atmospheric%20cinematic%20poster%2C%20golden%20and%20warm%20tones%2C%20romantic%20and%20melancholic%20mood&width=600&height=800&seq=movie-fh-10&orientation=portrait',
    description: '九十年代的上海，阿宝在改革开放的浪潮中抓住了机遇，从一个默默无闻的小人物成长为商界巨子。在繁华都市的背后，道尽人情冷暖、世事沧桑。',
    rating: 9.2,
    year: 2024,
    duration: '50分钟/集',
    isNew: true,
    isHot: true,
    episodes: 30,
  },
  {
    id: 'mv-011',
    title: '熊出没·逆转时空',
    category: 'anime',
    genre: ['动画', '喜剧'],
    image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20bears%20in%20a%20colorful%20time-travel%20adventure%20scene%20with%20clock%20gears%20and%20vortex%20portal%2C%20vibrant%20animated%20movie%20poster%20style%2C%20family%20friendly%20and%20fun%20atmosphere%2C%20bright%20greens%20and%20warm%20colors%2C%20playful%20composition&width=600&height=800&seq=movie-xcmnzsk-11&orientation=portrait',
    description: '熊大熊二和光头强意外穿越时空，来到一个全新的世界。在这里他们遇到了各种不可思议的事情，展开了一场既欢乐又感人的时空冒险之旅。',
    rating: 7.9,
    year: 2025,
    duration: '95分钟',
    isNew: true,
    isHot: false,
  },
  {
    id: 'mv-012',
    title: '歌手2025',
    category: 'variety',
    genre: ['音乐'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20music%20competition%20stage%20with%20dramatic%20spotlight%20and%20fog%20effects%2C%20microphone%20stand%20centered%20in%20golden%20light%2C%20grand%20orchestra%20silhouette%20in%20background%2C%20premium%20entertainment%20show%20poster%20style%2C%20dark%20elegant%20tones%20with%20golden%20accents&width=600&height=800&seq=movie-gs2025-12&orientation=portrait',
    description: '顶级音乐竞技节目，实力唱将巅峰对决。每一期都是一场视听盛宴，每一位歌手都在舞台上倾尽全力，用歌声诠释对音乐的热爱与执着。',
    rating: 8.4,
    year: 2025,
    duration: '120分钟/期',
    isNew: true,
    isHot: true,
  },
  {
    id: 'mv-013',
    title: '战狼3',
    category: 'movie',
    genre: ['动作', '战争'],
    image: 'https://readdy.ai/api/search-image?query=Heroic%20Chinese%20soldier%20standing%20against%20explosive%20battlefield%20backdrop%20with%20fire%20and%20smoke%2C%20holding%20national%20flag%2C%20epic%20action%20movie%20poster%20style%2C%20dramatic%20orange%20and%20dark%20tones%2C%20powerful%20and%20patriotic%20atmosphere&width=600&height=800&seq=movie-zl3-13&orientation=portrait',
    description: '冷锋再次踏上征程，这一次他要面对的是前所未有的国际阴谋。在异国他乡，他用自己的行动诠释了中国军人的担当与勇气。热血沸腾的军事动作大片。',
    rating: 8.3,
    year: 2026,
    duration: '135分钟',
    isNew: true,
    isHot: true,
  },
  {
    id: 'mv-014',
    title: '知否知否应是绿肥红瘦',
    category: 'tv',
    genre: ['古装', '爱情'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Song%20Dynasty%20Chinese%20garden%20with%20plum%20blossoms%20and%20traditional%20pavilion%2C%20graceful%20woman%20in%20ancient%20hanfu%20dress%20with%20flowing%20sleeves%2C%20soft%20natural%20lighting%2C%20romantic%20historical%20drama%20poster%20style%2C%20delicate%20pink%20and%20green%20palette&width=600&height=800&seq=movie-zfzf-14&orientation=portrait',
    description: '盛家六姑娘明兰从小聪颖貌美，却遭遇嫡母不慈、姐妹难缠、父亲不重视的困境。在逆境中她自立自强，历经艰难最终寻得良缘。古代社会家庭题材经典之作。',
    rating: 8.9,
    year: 2018,
    duration: '45分钟/集',
    isNew: false,
    isHot: false,
    episodes: 73,
  },
  {
    id: 'mv-015',
    title: '向往的生活',
    category: 'variety',
    genre: ['都市'],
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20Chinese%20countryside%20farmhouse%20with%20vegetable%20garden%20and%20wooden%20fence%2C%20golden%20sunset%20light%20over%20rice%20fields%2C%20simple%20rural%20life%20aesthetic%2C%20warm%20and%20cozy%20variety%20show%20poster%20style%2C%20natural%20green%20and%20golden%20tones&width=600&height=800&seq=movie-xwdsh-15&orientation=portrait',
    description: '远离城市喧嚣，回归田园生活。几位好友在乡间小院中自给自足，招待远道而来的朋友。在慢节奏的生活中，找回最纯粹的快乐和最真挚的友情。',
    rating: 8.6,
    year: 2025,
    duration: '85分钟/期',
    isNew: true,
    isHot: false,
  },
  {
    id: 'mv-016',
    title: '大江大河3',
    category: 'tv',
    genre: ['都市', '爱情'],
    image: 'https://readdy.ai/api/search-image?query=Industrial%20Chinese%20cityscape%20during%20economic%20reform%20era%20with%20factories%20and%20riverside%2C%20determined%20young%20man%20in%20vintage%20clothing%20looking%20toward%20horizon%2C%20historical%20drama%20poster%20style%2C%20muted%20warm%20industrial%20tones%2C%20hopeful%20and%20ambitious%20atmosphere&width=600&height=800&seq=movie-djdh3-16&orientation=portrait',
    description: '在改革开放的大时代背景下，宋运辉、雷东宝、杨巡三人的命运再次交织。面对新世纪的挑战与机遇，他们以各自的方式在时代洪流中砥砺前行。',
    rating: 9.0,
    year: 2026,
    duration: '45分钟/集',
    isNew: true,
    isHot: true,
    episodes: 36,
  },
];